import { combineReducers } from 'redux';

import filters from './filters';
import isDeleting from './isDeleting';
import isLoading from './isLoading';
import lockerIds from './lockerIds';
import page from './page';

export default combineReducers({
  page,
  filters,
  isLoading,
  isDeleting,
  ids: lockerIds,
});
